import { BACKEND_URL, PAY_STATUS, PRIORITY, STATUS, TASK_STATUS } from "../lib/api";

export function DotBadge({ value, map, testid }) {
  const cfg = map[value] || { label: value || "—", color: "#9CA3AF" };
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide whitespace-nowrap"
      style={{ color: cfg.color, backgroundColor: cfg.color + "1A", border: `1px solid ${cfg.color}33` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cfg.color }} />
      {cfg.label}
    </span>
  );
}

export const StatusBadge = ({ status, testid }) => <DotBadge value={status} map={STATUS} testid={testid} />;
export const TaskStatusBadge = ({ status, testid }) => <DotBadge value={status} map={TASK_STATUS} testid={testid} />;
export const PriorityBadge = ({ priority, testid }) => <DotBadge value={priority} map={PRIORITY} testid={testid} />;
export const PayBadge = ({ status, testid }) => <DotBadge value={status} map={PAY_STATUS} testid={testid} />;

export function UserAvatar({ name = "", color = "#1D225C", avatar, size = 8, testid }) {
  const initials = name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const cls = `h-${size} w-${size} rounded-full object-cover`;
  if (avatar) {
    return (
      <img
        data-testid={testid}
        src={avatar.startsWith("/") ? BACKEND_URL + avatar : avatar}
        alt={name}
        className={cls + " ring-1 ring-black/10"}
        style={{ width: size * 4, height: size * 4 }}
      />
    );
  }
  return (
    <span
      data-testid={testid}
      className="flex items-center justify-center rounded-full text-white font-semibold select-none"
      style={{ width: size * 4, height: size * 4, backgroundColor: color, fontSize: size * 1.6 }}
    >
      {initials || "?"}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, hint, children, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-[#1D225C]/15 bg-white/60 px-6 py-12 text-center"
    >
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#B88A4A]/10">
        <Icon className="h-6 w-6 text-[#B88A4A]" />
      </div>
      <p className="font-display text-base font-semibold text-[#1D225C]">{title}</p>
      {hint && <p className="mt-1 max-w-sm text-sm text-[#777]">{hint}</p>}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}

export function PageHeader({ overline, title, children, testid }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4" data-testid={testid}>
      <div>
        {overline && (
          <p className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#B88A4A]">{overline}</p>
        )}
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-[#1D225C]">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
